module.exports = __webpack_public_path__ + "static/img/left.1dc737b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/left.png
// module id = MQkY
// module chunks = 1